import DsEditor from './DsEditor'

export default Vue => {
  Vue.component(DsEditor.name, DsEditor)
}



// WEBPACK FOOTER //
// ./src/components/dseditor/index.js